import React from 'react'
import PropTypes from 'prop-types'

export const StudentNames = ({ entries, coursenum }) => {
  return (
    <table>
      <tbody>
        {entries.map(entry => (
          <tr key={entry.student.pk} className="customtable_row">
            <td className="customtable_cell customtable_last_name">
              <div className="gradebook_cell">
                <a href={`/course/progress/${coursenum}/${entry.student.pk}`}>
                  {entry.student.lastName}
                </a>
              </div>
            </td>
            <td className="customtable_first_name customtable_cell">
              <div className="gradebook_cell">
                <a href={`/course/progress/${coursenum}/${entry.student.pk}`}>
                  {entry.student.firstName}
                </a>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

StudentNames.propTypes = {
  entries: PropTypes.array.isRequired,
  coursenum: PropTypes.string.isRequired,
}
